import { ReactNode } from 'react';
import { Typography } from '@material-ui/core';


interface IProps {
    children: ReactNode
}

let RegistrationData = ({ children }: IProps) => {
    return (
        <Typography variant="h4" gutterBottom>
            {children}
        </Typography>
    )
}

export default RegistrationData;